import React, { useState, useEffect } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

// FIREBASE IMPORTS
import { getAuth } from "firebase/auth";
import { doc, updateDoc, arrayUnion, arrayRemove } from "firebase/firestore";
import { db } from "../firebase";

const FavoriteButton = ({ recipeId, isInitiallyFavorited }) => {
  const [isFavorited, setIsFavorited] = useState(!!isInitiallyFavorited);

  // Sync state if props change (important for filtering/pagination on the main feed)
  useEffect(() => {
      setIsFavorited(!!isInitiallyFavorited);
  }, [isInitiallyFavorited]);

  const handleFavoriteClick = async (e) => {
    e.stopPropagation(); // Prevent clicking the card from navigating to the details page
    
    // Check Auth
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
        alert("Please log in to save favorites!");
        return;
    }

    // Optimistic UI Update (Change icon instantly, revert if the database throws an error)
    const wasFavorited = isFavorited;
    setIsFavorited(!wasFavorited);

    try {
      const userRef = doc(db, "users", user.uid);

      if (wasFavorited) {
        // REMOVE: Safely pull the ID out of the user's favoriteIds array
        await updateDoc(userRef, {
            favoriteIds: arrayRemove(String(recipeId))
        });
      } else {
        // ADD: Safely push the ID into the user's favoriteIds array
        await updateDoc(userRef, {
            favoriteIds: arrayUnion(String(recipeId))
        });
      }
    } catch (error) {
      console.error("Failed to update favorite status", error);
      setIsFavorited(wasFavorited); // Revert the heart icon on error
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <Tooltip title={isFavorited ? "Remove from Favorites" : "Add to Favorites"}>
      <IconButton onClick={handleFavoriteClick} sx={{ color: '#D28415' }}>
        {isFavorited ? <FavoriteIcon /> : <FavoriteBorderIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default FavoriteButton;